import { Typography, Box } from '@mui/material'
import { type Sweepstake } from 'src/types/api'
import { EntryMultiplierSection } from './EntryMultiplierSection'
interface SweepstakeEntryMultiplierSectionProps {
  sweepstake: Sweepstake
}

export const SweepstakeEntryMultiplierSection = ({
  sweepstake,
}: SweepstakeEntryMultiplierSectionProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          pr: { xs: '0px', sm: '16px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: '16px',
            alignItems: { xs: 'flex-start', sm: 'center' },
          }}
        >
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ whiteSpace: 'nowrap' }}
          >
            Additional Sweepstake Entries
          </Typography>
        </Box>
      </Box>
      <EntryMultiplierSection sweepstake={sweepstake} />
    </Box>
  )
}
